import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './mediaInfo.css'
import { withTranslation } from 'react-i18next'

export class MediaInfo extends Component {

    static propTypes = {
        mediaInfo: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
    }

    render() {

        const { mediaInfo = {}, t } = this.props

        return (
            <div className="media-info">
                <h2>{t('visualizer:toolbar.left.mediaInfo.title')}</h2>

                <h3>{t('visualizer:toolbar.left.mediaInfo.media.title')}</h3>
                <div>
                    <label>{t('visualizer:toolbar.left.mediaInfo.media.fileName')}</label> : <span>{mediaInfo.filename}</span>
                </div>
                <div>
                    <label>{t('visualizer:toolbar.left.mediaInfo.media.id')}</label> : <span>{mediaInfo.id}</span>
                </div>
                <div>
                    <label>{t('visualizer:toolbar.left.mediaInfo.media.arkName')}</label> : <span>{mediaInfo.recordArkName}</span>
                </div>

            </div>

        )
    }
}

export default withTranslation()(MediaInfo)
